import classNames from 'classnames'
import { useRouter } from 'next/router'
import { FC } from 'react'
import Image from 'next/image'
import styles from './Testimonials.module.scss'
import { Testimonials as TestimonialsObject } from './constants'

const Testimonials: FC = () => {
  // Next router
  const { locale } = useRouter()

  return (
    <div className="container">
      <div className={styles['testimonials-container']}>
        {TestimonialsObject[locale].map((testimonial, index) => (
          <div key={index} className={styles.testimonial}>
            <Image
              src={`/images/features/home/testimonials/${testimonial.image}`}
              layout="fixed"
              width={80}
              height={80}
              alt={`Testimonial ${index}`}
            />

            <p className={styles['testimonial-description']}>{testimonial.text}</p>

            <p className={classNames(styles.name, 'margin-bottom-none')}>{testimonial.name}</p>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Testimonials
